import {createContext, useContext} from 'react';

import type {CountryListContextType} from './types';

// The context object and its hook live in this JSX-free module so that
// CountryListProvider.tsx only exports a component and keeps its Fast Refresh
// boundary. Consumers keep importing `useCountryList` from
// '@/context/CountryListContext'.
export const CountryListContext = createContext<
  CountryListContextType | undefined
>(undefined);

export const useCountryList = () => {
  const context = useContext(CountryListContext);
  if (!context) {
    throw new Error(
      'useCountryListContext must be used within a CountryListProvider',
    );
  }
  return context;
};
